import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Header } from "../components/Header";
import { ProjectCard } from "../components/ProjectCard";
import { listProjects, listTags } from "../lib/posts";

export function ProjectsPage() {
  const [activeTag, setActiveTag] = useState("all");
  const [query, setQuery] = useState("");
  const projectsQuery = useQuery({ queryKey: ["projects"], queryFn: listProjects });
  const tagsQuery = useQuery({ queryKey: ["tags"], queryFn: listTags });
  const projects = projectsQuery.data ?? [];
  const tags = tagsQuery.data ?? [];

  const filteredProjects = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return projects.filter((project) => {
      const matchesTag = activeTag === "all" || project.tags?.some((tag) => tag.slug === activeTag);
      const matchesQuery =
        !normalized ||
        project.title.toLowerCase().includes(normalized) ||
        project.summary.toLowerCase().includes(normalized) ||
        project.tags?.some((tag) => tag.name.toLowerCase().includes(normalized) || tag.slug.includes(normalized));
      return matchesTag && matchesQuery;
    });
  }, [activeTag, projects, query]);

  return (
    <>
      <Header />
      <main className="listing-shell">
        <section className="page-hero compact-hero">
          <span>/projects</span>
          <h1>Projects</h1>
          <p>
            Explore my projects, try the demos and discover the code behind each idea.
          </p>
        </section>
        <div className="toolbar projects-toolbar" role="search">
          <div className="project-filter-select">
            <label htmlFor="project-technology-filter">Filter by technology</label>
            <select id="project-technology-filter" value={activeTag} onChange={(event) => setActiveTag(event.target.value)}>
              <option value="all">All projects</option>
              {tags.map((tag) => <option key={tag.slug} value={tag.slug}>{tag.name}</option>)}
            </select>
          </div>
          <label className="search-box">
            <span>Search</span>
            <input onChange={(event) => setQuery(event.target.value)} placeholder="Project, technology or tag…" value={query} />
          </label>
        </div>
        <p className="project-count">
          Showing {filteredProjects.length} of {projects.length} projects.
        </p>
        <div className="project-grid all-projects">
          {filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </main>
    </>
  );
}
